module.exports = __webpack_public_path__ + "img/wsib_logo.b59d2b75.png";